import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import {
  AssetConditionConfigModel,
  AssetConditionModel,
  AssetConditionPayloadModel,
  ResponseModelV3,
  ThresholdEditModel
} from 'src/app/model';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-asset-condition',
  templateUrl: './asset-condition.component.html',
  styleUrls: ['./asset-condition.component.css']
})
export class AssetConditionComponent implements OnInit, OnChanges, OnDestroy {
  
  @Input() entityId: any;
  @Input() widgetData: any;

  guageData: any = [];
  isError: boolean = false;
  isloader: boolean = true;
  gaugeSteps: AssetConditionConfigModel;

  // Threshold Edit
  onAssetConditionLoading = true;
  thresholdContent: ThresholdEditModel;

  readonly MESSAGES = Messages;

  private _startTime: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
  private _subscription: Subscription;
  private _gaugeProperty: any = null;
  private _getAssetConditionSubscription: Subscription;

  constructor(
    private _service: EntitiesServiceService,
    private _datePipe: DatePipe,
    private _dataSer: DataService,
    public sharedService: ServicecallService
  ) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this._getAssetCondition();
      }
    });
  }

  ngOnInit(): void {
    this._gaugeProperty = this.sharedService.getConfiguration('gaugeProperty') ? this.sharedService.getConfiguration('gaugeProperty')?.gaugeProperty : null;
  }

  ngOnChanges(): void {
    this._getAssetCondition();
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._getAssetConditionSubscription?.unsubscribe();  
  }

  /**
   * Determines whether threshold value change on
   */
  onThresholdValueChange() {
    this._getAssetCondition();
  }

  /**
   * Gets asset condition
   */
  private _getAssetCondition() {
    this.onAssetConditionLoading = true;
    // Payload
    const payload: AssetConditionPayloadModel = {
      from: this._datePipe.transform(this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityId,
      attributeName: 'Temperature °F'
    };
    this.isError = false;
    this._getAssetConditionSubscription = this._service?.getEntityAttributeStatus(payload)?.subscribe(
      {
        next: (result: ResponseModelV3<AssetConditionModel>) => {
          if (result?.status) {
            if (result?.response?.data) {
              // Set loading status
              this.onAssetConditionLoading = false;
              const assetStatus = result?.response?.data;
              this.gaugeSteps = {
                scaleLowerLimit: assetStatus?.scaleLowerLimit ? assetStatus?.scaleLowerLimit : +this._gaugeProperty?.scaleLowerLimit,
                scaleUpperLimit: assetStatus?.scaleUpperLimit ? assetStatus?.scaleUpperLimit : +this._gaugeProperty?.scaleUpperLimit, 
                thresholdLowerLimit: assetStatus?.thresholdLowerLimit ? assetStatus?.thresholdLowerLimit : +this._gaugeProperty?.thresholdLowerLimit, 
                thresholdUpperLimit: assetStatus?.thresholdUpperLimit ? assetStatus?.thresholdUpperLimit : +this._gaugeProperty?.thresholdUpperLimit
              };
              this._setThreshold();
              this.guageData = [
                {
                  type: 'indicator',
                  value: assetStatus?.windowAvg,
                  delta: { reference: 160 },
                  number: { font : { size: 40 } },
                  gauge: {
                    borderwidth: 0,
                    axis: { visible: true, range: [this.gaugeSteps?.scaleLowerLimit, this.gaugeSteps?.scaleUpperLimit] },
                    bar: { color: 'transparent' },
                    steps: [
                      { 'range': [this.gaugeSteps?.thresholdLowerLimit, this.gaugeSteps?.thresholdUpperLimit], 'color': '#44bd32' },
                      { 'range': [this.gaugeSteps?.scaleLowerLimit, this.gaugeSteps?.thresholdLowerLimit], 'color': '#ff7979' },
                      { 'range': [this.gaugeSteps?.thresholdUpperLimit, this.gaugeSteps?.scaleUpperLimit], 'color': '#ff7979' }
                    ],
                    threshold: { 'line': { 'color': '#132bb0', 'width': 4, 'stroke-linejoin': 'round' }, 'thickness': .7, 'value': assetStatus?.windowAvg }
                  },
                  domain: { row: 0, column: 0 },
                  status: assetStatus?.status,
                  color: assetStatus?.colour,
                  height: 180,
                  annotation: [
                    {
                      text: '°F',
                      showarrow: false,
                      font: {
                        family: "Inter",
                        size: 20
                      }
                    }
                  ]
                }
              ];
            } else {
              this.isError = true;
            }
          } else {
            this.isError = true;
          }
          this.isloader = false;
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
          }
        }
      }
    )
  }

  /**
   * Sets threshold
   */
  private _setThreshold() {
    this.thresholdContent = {
      entityId: this.entityId,
      attributeName: 'Temperature °F',
      threshold: {
        lowerLimit: this.gaugeSteps?.thresholdLowerLimit,
        upperLimit: this.gaugeSteps?.thresholdUpperLimit
      }
    }
  }
}
